import { message } from "antd";
import axios from "axios";

const httpService: any = async (
  url: string,
  method: string,
  data?: {},
  params?: {}
) => {
  let accessToken: any = localStorage.getItem("AccessToken");

  try {
    const refreshToken = localStorage.getItem("RefreshToken");

    const config = {
      url,
      method,
      data,
      headers: {
        ...(accessToken && { AccessToken: accessToken }),
        ...(refreshToken && { RefreshToken: refreshToken }),
      },
      params,
      validateStatus: function (status: number) {
        return status >= 200 && status < 400; // Reject only if the status code is outside of the 2xx range
      },
    };

    const response = await axios(config);

    return response.data;
  } catch (err: any) {
    const error = err?.response?.data;
    const status = err?.response?.status;

    // Only treat HTTP 401 (or explicit auth body status) as an expired-access-token case.
    // Do not logout when the retried request itself fails for other reasons.
    if (status === 401 || error?.status === 401) {
      try {
        const refreshToken = localStorage.getItem("RefreshToken");

        const refreshResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/authentication/refresh`,
          {},
          { headers: { RefreshToken: refreshToken } }
        );

        accessToken = refreshResponse.data.data.AccessToken;
        localStorage.setItem("AccessToken", accessToken);

        const retryConfig = {
          url,
          method,
          data,
          headers: {
            AccessToken: accessToken,
            ...(refreshToken && { RefreshToken: refreshToken }),
          },
          params,
          validateStatus: function (retryStatus: number) {
            return retryStatus >= 200 && retryStatus < 400;
          },
        };

        try {
          const retryResponse = await axios(retryConfig);
          return retryResponse.data;
        } catch (retryError: any) {
          // Access token was refreshed; surface the original/retry API error instead of logging out.
          return retryError?.response?.data ?? error;
        }
      } catch (refreshError) {
        console.error("Failed to refresh access token", refreshError);

        message.error("Refresh Token has expired, please log in");

        const isAdminRoute = window.location.pathname.startsWith("/admin");
        window.location.href = isAdminRoute ? "/admin" : "/";

        return;
      }
    }

    return error;
  }
};

export default httpService;
